import { DeleteButton, Edit } from "@refinedev/mui";
import { TextField, Box, CircularProgress } from "@mui/material";
import { useForm } from "@refinedev/react-hook-form";
import { useNavigate, useParams } from "react-router-dom";

export const UpdateTag = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    refineCore: { formLoading },
    saveButtonProps,
    register,
    formState: { errors, isLoading },
  } = useForm({
    refineCoreProps: {
      resource: "tags",
      errorNotification: (error) => {
        return {
          message: error?.message?.includes("duplicate key value")
            ? "Tag already exist"
            : error?.message?.includes("violates foreign key constraint")
            ? "The following Tag is used in the platform and can not be deleted!"
            : "Oops! something went wrong, please try later.",
          type: "error",
        };
      },
    },
    warnWhenUnsavedChanges: true,
  });

  return (
    <Edit
      isLoading={isLoading || formLoading}
      saveButtonProps={saveButtonProps}
      footerButtons={({ defaultButtons }) => (
        <>
          {defaultButtons}
          <DeleteButton
            recordItemId={id}
            variant="outlined"
            onSuccess={() => {
              navigate(`/tags`);
            }}
            errorNotification={(error: any) => {
              return {
                message: error?.message?.includes(
                  "violates foreign key constraint"
                )
                  ? "The following tag is used in the platform and can not be deleted!"
                  : "Oops! something went wrong, please try later.",
                type: "error",
              };
            }}
          />
        </>
      )}
    >
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        {isLoading || formLoading ? (
          <CircularProgress />
        ) : (
          <form>
            <TextField
              {...register("tagName", {
                required: "This tag name is required",
              })}
              error={!!(errors as any)?.title}
              helperText={(errors as any)?.title?.message}
              margin="normal"
              fullWidth
              InputLabelProps={{ shrink: true }}
              type="text"
              label="Tag Name"
              name="tagName"
            />
          </form>
        )}
      </Box>
    </Edit>
  );
};
